import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid grid-cols-1 md:grid-cols-2">
      <div className="flex items-center justify-center p-8 order-2 md:order-1">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-accent mb-2">Join Bundles and Blends</div>
          <h1 className="font-heading font-black text-4xl uppercase tracking-tighter mb-8">Create Account</h1>
          {error && <div data-testid="register-error" className="bg-destructive/10 text-destructive text-sm p-3 mb-4 border border-destructive/20">{error}</div>}
          <label className="block text-xs font-bold uppercase tracking-[0.2em] mb-2">Name</label>
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)}
            className="w-full border border-input px-4 py-3 mb-5 outline-none focus:ring-2 focus:ring-ring text-sm" />
          <label className="block text-xs font-bold uppercase tracking-[0.2em] mb-2">Email</label>
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-input px-4 py-3 mb-5 outline-none focus:ring-2 focus:ring-ring text-sm" />
          <label className="block text-xs font-bold uppercase tracking-[0.2em] mb-2">Password</label>
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-input px-4 py-3 mb-6 outline-none focus:ring-2 focus:ring-ring text-sm" />
          <button type="submit" disabled={loading} data-testid="register-submit"
            className="w-full bg-foreground text-background py-4 text-xs font-bold uppercase tracking-[0.25em] hover:bg-black/80 transition-colors disabled:opacity-60">
            {loading ? "Creating…" : "Create Account"}
          </button>
          <p className="mt-6 text-sm text-muted-foreground text-center">Have an account? <Link to="/login" className="text-foreground font-medium hover:text-accent">Sign in</Link></p>
        </form>
      </div>
      <div className="hidden md:block bg-foreground relative overflow-hidden order-1 md:order-2">
        <img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1" alt="" className="w-full h-full object-cover opacity-70" />
      </div>
    </div>
  );
}
